import React, { useState } from 'react';
import { Col, Label, Input, Button, FormGroup, Row, Tooltip } from 'reactstrap';
import * as Icon from 'react-feather';
import { ComponentCard } from '../layout/ComponentCard';

export const ExcepcionFCT = ({
  local,
  previous,
  next,
  beginning,
  empresaId,
  nombreGrupo,
  variant,
  setExcepcion,
}) => {
  // Preparamos variables necesarias
  const [choosen, setChoosen] = useState(true);

  const [toolTip, setToolTip] = useState({
    t0: { open: false, text: 'El alumno no pide exepción' },
    t25: {
      open: false,
      text: 'Haber trabajado el mismo número de horas que el propio crédito en cualquier ámbito',
    },
    t50: {
      open: false,
      text: 'Haber trabajado en el mismo ámbito sanitario correspondiente y pudiendo probarlo',
    },
    t100: {
      open: false,
      text: 'Experiencia relacionada que, al igual que el 50%, sea demostrable por el alumno',
    },
  });

  const fullName = `${local.nombre} ${local.apellidos}`;

  // Función que controla el cambio de tipo de excpecion
  const handleOnChangeType = (e) => {
    setChoosen(false);
    setExcepcion(e.target.value);
  };

  const toogle = (tooltip) => {
    setToolTip((prev) => ({ ...prev, [tooltip]: { ...prev[tooltip], open: !prev[tooltip].open } }));
  };

  return (
    <Col md="12">
      <ComponentCard
        title={`Excepción FCT - ${empresaId}`}
        hasButton={false}
        className="clearfix"
        name={fullName}
      >
        <>
          <Row style={{ marginTop: '-20px', marginBottom: '16px' }}>
            <Col md="12">
              <b>{nombreGrupo}</b>
            </Col>
          </Row>
          <FormGroup>
            <Row>
              <Label>
                <Input
                  type="radio"
                  name="parcial"
                  value="0"
                  onChange={handleOnChangeType}
                  style={{ position: 'inherit', opacity: 1, marginRight: '5px' }}
                />
                Sin excepción{' '}
                <font color="#adb5bd">
                  <Icon.HelpCircle id="ex-0" />
                </font>
              </Label>
              <Tooltip
                placement="right"
                isOpen={toolTip.t0.open}
                target="ex-0"
                toggle={() => toogle('t0')}
              >
                {toolTip.t0.text}
              </Tooltip>
            </Row>
            <Row>
              <Label>
                <Input
                  type="radio"
                  name="parcial"
                  value="25"
                  onChange={handleOnChangeType}
                  style={{ position: 'inherit', opacity: 1, marginRight: '5px' }}
                />
                Excepción del 25%{' '}
                <font color="#adb5bd">
                  <Icon.HelpCircle id="ex-25" />
                </font>
              </Label>
              <Tooltip
                placement="right"
                isOpen={toolTip.t25.open}
                target="ex-25"
                toggle={() => toogle('t25')}
              >
                {toolTip.t25.text}
              </Tooltip>
            </Row>
            <Row>
              <Label>
                <Input
                  type="radio"
                  name="parcial"
                  value="50"
                  onChange={handleOnChangeType}
                  style={{ position: 'inherit', opacity: 1, marginRight: '5px' }}
                />
                Excepción del 50%{' '}
                <font color="#adb5bd">
                  <Icon.HelpCircle id="ex-50" />
                </font>
              </Label>
              <Tooltip
                placement="right"
                isOpen={toolTip.t50.open}
                target="ex-50"
                toggle={() => toogle('t50')}
              >
                {toolTip.t50.text}
              </Tooltip>
            </Row>
            <Row>
              <Label>
                <Input
                  type="radio"
                  name="parcial"
                  value="100"
                  onChange={handleOnChangeType}
                  style={{ position: 'inherit', opacity: 1, marginRight: '5px' }}
                />
                Excepción del 100%{' '}
                <font color="#adb5bd">
                  <Icon.HelpCircle id="ex-100" />
                </font>
              </Label>
              <Tooltip
                placement="right"
                isOpen={toolTip.t100.open}
                target="ex-100"
                toggle={() => toogle('t100')}
              >
                {toolTip.t100.text}
              </Tooltip>
            </Row>
          </FormGroup>
          <div className="pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={previous}>Atrás</Button>
            <Button onClick={beginning}>
              {variant === 'portal' ? 'Volver a detalles' : 'Volver a la ficha de alumno'}
            </Button>
            <Button disabled={choosen} onClick={() => next(0)}>
              Siguiente
            </Button>
          </div>
        </>
      </ComponentCard>
    </Col>
  );
};
